module.exports = __webpack_public_path__ + "img/3.a4a29dc7.jpg";